import SettingsCard from '../components/settings/SettingsCard'
import { faUser, faPencil } from '@fortawesome/free-solid-svg-icons'
import { useContext } from 'react'
import SettingsContext from '../components/contexts/SettingsContext'
import { Outlet, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'

function Settings() {
   const { currentTab, setCurrentTab, showAlert, setShowAlert } = useContext(SettingsContext)
   const navigator = useNavigate()

   const closeAlert = () => {
      setShowAlert(false)
   }

   const deleteData = () => {
      console.log("User ", sessionStorage.getItem('user'))
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/users/' +
            sessionStorage.getItem('user') + '?relatedObjectsAction=delete',
         {
            method: 'DELETE',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
      .then((result) => {
         console.log('Success: deleted user')
         navigator('/')
         setShowAlert(false)
      })
      .catch((error) => {
         console.error('Error:')
      })
   }

   useEffect(() => {
      document.title = "Settings";  
      document.documentElement.lang = "en";
   }, []);

   return (
      <div className="settingsScreen">
         {showAlert && <div className="settings_warning_deleteAccount">
            <div className="deleteAccount_header">Warning!</div>
            <div className="settings_warning_description">
               You are about to delete your account and all its information.
               This process can not be reversed and your data will be
               deleted permanently. Do you wish to continue?
            </div>
            <div className='settings_warning_choice'>
               <button className='warning_yesButton' onClick={deleteData}>Yes</button>
               <button className='warning_noButton' onClick={closeAlert}>No</button>
            </div>
         </div>}
         <div className="settingsDivider">
            <div className="div_settingsList">
               <div className="headerSettings">Settings</div>
               <ul className="settingsList">
                  <li
                     className="listInstance_settings"
                     onClick={() => {
                        setCurrentTab('account')
                        navigator('account')
                     }}
                  >
                     <SettingsCard
                        icon={faUser}
                        name={'Account'}
                        isArrowed={true}
                        isActive={currentTab == 'account'}
                     />
                  </li>
                  <li
                     className="listInstance_settings"
                     onClick={() => {
                        // setCurrentTab('styleSheet')
                        navigator('/style')
                     }}
                  >
                     <SettingsCard
                        icon={faPencil}
                        name={'Style Sheet'}
                        isArrowed={false}
                        // isActive={currentTab == 'styleSheet'}
                     />
                  </li>
               </ul>
            </div>
            <div className="settingsChoose">
               <Outlet />
            </div>
         </div>
      </div>
   )
}
export default Settings
